module.exports = __webpack_public_path__ + "img/headshot-UyenCampbell.89c4379e.jpg";